export enum SettingsType {
  PROFILE = 'profile',
  SNIPPETS = 'snippets',
  FAX = 'fax',
  PHONE = 'phone',
  NOTIFICATIONS = 'notifications',
  AUDIO = 'audio',
  BLOCKED_NUMBERS = 'blocked_numbers',
  CALL_CENTER = 'call_center',
  EXPERIMENTS = 'experiments',
  SHORTCUTS = 'shortcuts',
  UPDATES = 'updates',
  INTEGRATIONS = 'integrations',
}
